const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，恋情曝光全记录', heat: '热度 985万', trend: 'up' },
  { rank: 2, title: '知名导演新片黑料流出，剧组内部矛盾大揭秘', heat: '热度 872万', trend: 'up' },
  { rank: 3, title: '综艺录制现场突发意外，嘉宾翻车视频全网疯传', heat: '热度 756万', trend: 'up' },
  { rank: 4, title: '网红带货翻车后续：品牌方索赔巨额损失费', heat: '热度 689万', trend: 'same' },
  { rank: 5, title: '女星小号被扒内容劲爆，引发大规模脱粉潮', heat: '热度 621万', trend: 'down' },
  { rank: 6, title: '娱乐圈资本局大起底：多位明星损失惨重', heat: '热度 534万', trend: 'up' },
  { rank: 7, title: '影视剧原作者质疑改编，编剧团队回应引热议', heat: '热度 478万', trend: 'same' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            实时更新的黑料热度排行，看看今天最火的瓜是什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 md:px-7 py-4 hover:bg-background-200/50 transition-colors cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-label font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                    ? 'bg-secondary-400 text-white'
                    : item.rank === 3
                    ? 'bg-secondary-300 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>

                <div className="flex-shrink-0 flex items-center gap-2">
                  <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:inline">
                    {item.heat}
                  </span>
                  <span className={`text-xs font-label font-semibold whitespace-nowrap ${
                    item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-secondary-500' : 'text-foreground-400'
                  }`}>
                    {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                    {item.trend === 'same' && <i className="ri-subtract-line mr-0.5"></i>}
                    {item.trend === 'up' ? '升' : item.trend === 'down' ? '降' : '平'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}